import { render, staticRenderFns } from "./Server.vue?vue&type=template&id=7b8c0621&scoped=true&"
import script from "./Server.vue?vue&type=script&lang=ts&"
export * from "./Server.vue?vue&type=script&lang=ts&"
import style0 from "./Server.vue?vue&type=style&index=0&id=7b8c0621&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8c0621",
  null
  
)

export default component.exports